import { useCallback } from 'react';

import { mapLinkVacancies } from '../../../services/vacancies/vacancies.utils';
import { VacanciesResponseInterface } from '../../../types/vacancies.types';
import { isInIframe } from '../../../utils/iframe';
import { useLanguage } from '../../useLanguage';
import { useToggles } from '../../useToggles';
import { ApiResponseTransformer } from '../useApiService';

export const useVacanciesLinkTransformer =
  (): ApiResponseTransformer<VacanciesResponseInterface> => {
    const { language } = useLanguage();
    const {
      features: { HB5540_new_vacancy_details },
      ops: { jobDetailUrls },
    } = useToggles();

    return useCallback(
      (response?: VacanciesResponseInterface) =>
        mapLinkVacancies(
          language,
          response,
          isInIframe(),
          jobDetailUrls,
          HB5540_new_vacancy_details
        ),
      [language, jobDetailUrls, HB5540_new_vacancy_details]
    );
  };
